<div class="lt-root" [class.dense]="dense" [class.mobile-feed]="mobileFeed" [class.is-empty]="isEmpty" [class.is-failed]="status==='failed'" (click)="onSelect()">
  <div class="lt-header" *ngIf="!isEmpty || !dense" [class.minimal]="isEmpty">
    <div class="lt-left">
      <div class="lt-name-row">
        <div class="lt-name">{{ title }}</div>
        <span
          *ngIf="showRustAgentBetaBadge"
          class="agent-beta-badge agent-beta-badge--name"
          [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
          matTooltipPosition="below"
          (click)="$event.stopPropagation()">{{ sysConfig.rustAgentBetaBadge }}</span>
      </div>
      <div class="lt-sub" *ngIf="!isEmpty && tile?.employee?.meta?.last_application_name">
        {{ tile?.employee?.meta?.last_application_name }}
      </div>
    </div>

    <div class="lt-actions" *ngIf="!isEmpty">
      <span class="lt-dup-badge" *ngIf="duplicateCount > 1">dup x{{ duplicateCount }}</span>
      <span class="lt-badge" [class.live]="status==='live'" [class.connecting]="status==='connecting'"
        [class.failed]="status==='failed'" [class.offline]="status==='offline'">
        {{ status }}
      </span>
      <button type="button" class="lt-icon-btn" *ngIf="canRetry" title="Retry" (click)="onRetry($event)">
        <span class="material-symbols-outlined">refresh</span>
      </button>
      <button type="button" class="lt-icon-btn" *ngIf="canSnapshot" title="Snapshot" (click)="onSnapshot($event)">
        <span class="material-symbols-outlined">photo_camera</span>
      </button>
      <button type="button" class="lt-close" *ngIf="canClose" title="Close stream" (click)="onClose($event)">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <div class="lt-body">
    <video *ngIf="tile?.mediaStream" class="lt-video" [ssSrcObject]="tile?.mediaStream" autoplay muted playsinline></video>
    <div class="lt-mobile-expand-hint" *ngIf="mobileFeed && tile?.mediaStream" aria-hidden="true">
      <span class="material-symbols-outlined">open_in_full</span>
      Tap for full screen
    </div>

    <div class="lt-overlay" *ngIf="!tile?.mediaStream">
      <div class="lt-drop-zone" [class.is-empty-zone]="isEmpty">
        <div class="lt-empty-icon" *ngIf="isEmpty">
          <span class="material-symbols-outlined">desktop_windows</span>
        </div>
        <div class="lt-overlay-title">{{ isEmpty ? emptyTitle : (status | titlecase) }}</div>
        <div class="lt-overlay-sub" *ngIf="tile?.errorMessage">{{ tile?.errorMessage }}</div>
        <div class="lt-overlay-sub" *ngIf="!tile?.errorMessage && isEmpty && !dense">
          {{ emptySubtitle }}
        </div>
      </div>
    </div>
  </div>
</div>

